import { actions } from './document_type/actions'
import { getters } from './document_type/getters'
import { state } from './document_type/state'
import { mutations } from './document_type/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}